/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PromptSkuDetails {
    getFixupPrototypeFunction() { return PromptSkuDetails.fixupPrototype; }

    static newInstance(model: Partial<PromptSkuDetails>): PromptSkuDetails {
        let obj = Object.assign(new PromptSkuDetails(), model);
        PromptSkuDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PromptSkuDetails>): PromptSkuDetails {
        if (!model) return null;
        return PromptSkuDetails.newInstance(<PromptSkuDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PromptSkuDetails) {
        if (!obj) return;

        models.PromptSkuDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PromptSkuDetails): boolean {
        Object.setPrototypeOf(obj, PromptSkuDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.latency_ms === undefined) {
            this.latency_ms = 0;
        }
        if (this.accuracy === undefined) {
            this.accuracy = 0;
        }
        if (this.cost === undefined) {
            this.cost = 0;
        }
    }

    /**
     * Model identifier
     */
    model_id: string;

    /**
     * Mean endpoint latency in milliseconds
     */
    latency_ms: number;

    /**
     * Task accuracy score 0.0-1.0
     */
    accuracy: number;

    /**
     * Per-invocation cost in USD
     */
    cost: number;

}
